import React from 'react'
import { useTranslation } from 'react-i18next'

import { DeliveryForecastItemPreviousDelivery } from '../../../../../../data/models'
import {
  ConfigurableTable,
  convertDeliveryForecastItems,
} from '../../../../../../utils/wrapper'
import { useConfigContext } from '../../../../../ui-config'

type Props = {
  items: DeliveryForecastItemPreviousDelivery[] | undefined
  isLoading: boolean
}

export const PreviousDeliveriesTable: React.FC<Props> = ({
  items,
  isLoading,
}) => {
  const { t } = useTranslation()
  const { uiConfig: config } = useConfigContext()

  return (
    <>
      <h3>
        {t('deliveryForecast.deliveryScheduleDetails.previousDeliveries.title')}
      </h3>
      <ConfigurableTable
        config={
          config.deliveryForecast.deliveryScheduleDetails
            .previousDeliveriesTable.table
        }
        data={convertDeliveryForecastItems(items)}
        isLoading={isLoading}
        dataKey="DeliveryDate"
        stateKey=""
      />
    </>
  )
}
